"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YOUTUBE_MEDIA_URL = exports.YOUKU_MEDIA_URL = exports.PAGE_ID_PATH = exports.OverlayPosition = exports.LINK_TYPE_PRODUCT = exports.APP_NAME = exports.APPLICATION_NAME = void 0;
const LINK_TYPE_PRODUCT = exports.LINK_TYPE_PRODUCT = 'Product';
const PAGE_ID_PATH = exports.PAGE_ID_PATH = 'campaigns/editorials';
const YOUTUBE_MEDIA_URL = exports.YOUTUBE_MEDIA_URL = 'https://www.youtube.com/embed/';
const YOUKU_MEDIA_URL = exports.YOUKU_MEDIA_URL = 'https://player.youku.com/embed/';
const APP_NAME = exports.APP_NAME = 'editorial-page';
const APPLICATION_NAME = exports.APPLICATION_NAME = "@ori/".concat(APP_NAME);
let OverlayPosition = exports.OverlayPosition = /*#__PURE__*/ function(OverlayPosition) {
    OverlayPosition["Left"] = "left";
    OverlayPosition["Right"] = "right";
    return OverlayPosition;
}({});
